import { getToken, removeToken } from './auth';

export async function verifyToken() {
  const token = getToken();
  if (!token) return false;
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/check-login`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (response.ok) return true;
    removeToken();
    return false;
  } catch {
    removeToken();
    return false;
  }
}
